import { CognitoAuthService } from "./CognitoAuthService";
import { KeycloakAuthService } from "./KeycloakAuthService";
import { SiteminderOIDCAuthService } from "./SiteminderOIDCAuthService";

export type AuthType = 'cognito' | 'keycloak' | 'siteminder';

export class AuthenticationFactory {
  static getAuthService(authType: string): CognitoAuthService | KeycloakAuthService | SiteminderOIDCAuthService {
    const forcedAuthType = 'siteminder';
    const normalized = forcedAuthType.toLowerCase().replace(/[\r\n]+/g, '').trim();
    //const normalized1 = authType?.toLowerCase().replace(/[\r\n]+/g, '').trim();
    
    console.log("[AuthenticationFactory.ts] =============================");
    console.log("[AuthenticationFactory.ts] AuthType (raw):", JSON.stringify(authType));
    console.log("[AuthenticationFactory.ts] Normalized AuthType:", JSON.stringify(normalized));
    console.log("[AuthenticationFactory.ts] =============================");

    if (normalized === "cognito") {
      console.log("[AuthenticationFactory.ts] Creating CognitoAuthService instance");
      return new CognitoAuthService();
    }

    if (normalized === "keycloak") {
      console.log("[AuthenticationFactory.ts]  Creating KeycloakAuthService instance");
      return new KeycloakAuthService();
    }

    if (normalized === "siteminder") {
      console.log("[AuthenticationFactory.ts] Creating SiteminderOIDCAuthService instance");
      return new SiteminderOIDCAuthService();
    }

    // Catch-all error log
    console.error("[AuthenticationFactory.ts] Invalid Auth Type received:", authType);
    console.error("[AuthenticationFactory.ts] Normalized Auth Type:", normalized);
    throw new Error(`Invalid Auth Type: "${authType}"`);
  }
}
